import { gql } from '@apollo/client'
import { OwnerFragment } from '@src/graphql/fragment/account'
import { ApostleCommonFragment } from '@src/graphql/fragment/apostle'
import { ListingInfoFragment } from '@src/graphql/fragment/listingInfo'

export const CoreFragment = gql`
  fragment Core on Planet {
    breedCount
    breedCountMax
    image
    name
    planetID
  }
`

export const PlanetSuperLiteFragment = gql`
  fragment PlanetSuperLite on Planet {
    ageDisplay
    name
    planetID
  }
`

export const PlanetLiteFragment = gql`
  fragment PlanetLite on Planet {
    ...PlanetSuperLite
    air
    availableAttachTime
    battlePassLock
    bornTime
    breedCount
    breedCountMax
    childrenIDs
    coreType
    earth
    fire
    generation
    image
    lastBreedTime
    nftListingStatus
    planetClass
    planetCreateTime
    planetType
    priceInUSD
    stage
    status
    water
    parentIDs
    listingInfo {
      ...ListingInfo
    }
    owner {
      ...Owner
    }
    relicApostleSlot {
      ageSlotCount
    }
    relicsTokens {
      description
      id
      image
      name
      thumbnail
    }
  }

  ${PlanetSuperLiteFragment}
  ${ListingInfoFragment}
  ${OwnerFragment}
`

export const PlanetMiddleLiteFragment = gql`
  fragment PlanetMiddleLite on Planet {
    ...PlanetLite
    relicApostles {
      apostleCommon {
        ...ApostleCommon
      }
      apostleID
      planetApostleID
    }
    relicApostleSlot {
      ageSlotCount
    }
  }

  ${PlanetLiteFragment}
  ${ApostleCommonFragment}
`

export const PlanetFieldsFragment = gql`
  fragment PlanetFields on Planet {
    ageDisplay
    breedCount
    coreType
    image
    name
    planetID
    planetType
    stage
    relicsTokens {
      description
      id
      image
      name
      thumbnail
    }
  }
`

export const PlanetFragment = gql`
  fragment Planet on Planet {
    ...PlanetMiddleLite
    armor
    atkPow
    atkRange
    atkSpeed
    availableAttachTime
    bornTime
    critChance
    critDmg
    cSkill1
    cSkill2
    cSkill3
    energy
    health
    primevalLegacy
    pSkill1
    pSkill2
    weapon
    children {
      ...PlanetFields
    }
    parents {
      ...PlanetFields
    }
  }

  ${PlanetMiddleLiteFragment}
  ${PlanetFieldsFragment}
`
